import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MDBModalRef, MDBModalService } from 'ng-uikit-pro-standard';
import { AuthModalComponent } from 'src/app/auth/components/auth-modal/auth-modal.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  modalRef: MDBModalRef;

  @Input () customHeader: boolean = false

  hiddenHeader = ['/complemento-cadastro']

  constructor(private modalService: MDBModalService, private router: Router) { }

  ngOnInit(): void {
  }

  get isHiddenHeader(): boolean {
    return this.hiddenHeader.includes(this.router.url);
  }

  openModal(){
    let config = {
      ignoreBackdropClick: true,
      scroll: true
    }
    this.modalRef = this.modalService.show(AuthModalComponent, config)
  }
}
